import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Card } from '@/shared/ui/core';
import styles from './auth-card.module.scss';


export function AuthCard ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <Card
            className={ cn(styles.root, className) }
            data-template='auth-card'
            { ...props }
        />
    );
}
